// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CmiY","rightAdornment":"Header_rightAdornment__2PTuC"};